export const NorthAmericanStates = Object.freeze([
  { postalCode: 'AL', label: 'Alabama' },
  { postalCode: 'AZ', label: 'Arizona' },
  { postalCode: 'AR', label: 'Arkansas' },
  { postalCode: 'CA', label: 'California' },
  { postalCode: 'CO', label: 'Colorado' },
  { postalCode: 'CT', label: 'Connecticut' },
  { postalCode: 'DE', label: 'Delaware' },
  { postalCode: 'FL', label: 'Florida' },
  { postalCode: 'GA', label: 'Georgia' },
  { postalCode: 'ID', label: 'Idaho' },
  { postalCode: 'IL', label: 'Illinois' },
  { postalCode: 'IN', label: 'Indiana' },
  { postalCode: 'IA', label: 'Iowa' },
  { postalCode: 'KS', label: 'Kansas' },
  { postalCode: 'KY', label: 'Kentucky' },
  { postalCode: 'LA', label: 'Louisiana' },
  { postalCode: 'ME', label: 'Maine' },
  { postalCode: 'MD', label: 'Maryland' },
  { postalCode: 'MA', label: 'Massachusetts' },
  { postalCode: 'MI', label: 'Michigan' },
  { postalCode: 'MN', label: 'Minnesota' },
  { postalCode: 'MS', label: 'Mississippi' },
  { postalCode: 'MO', label: 'Missouri' },
  { postalCode: 'MT', label: 'Montana' },
  { postalCode: 'NE', label: 'Nebraska' },
  { postalCode: 'NV', label: 'Nevada' },
  { postalCode: 'NH', label: 'New Hampshire' },
  { postalCode: 'NJ', label: 'New Jersey' },
  { postalCode: 'NM', label: 'New Mexico' },
  { postalCode: 'NY', label: 'New York' },
  { postalCode: 'NC', label: 'North Carolina' },
  { postalCode: 'ND', label: 'North Dakota' },
  { postalCode: 'OH', label: 'Ohio' },
  { postalCode: 'OK', label: 'Oklahoma' },
  { postalCode: 'OR', label: 'Oregon' },
  { postalCode: 'PA', label: 'Pennsylvania' },
  { postalCode: 'RI', label: 'Rhode Island' },
  { postalCode: 'SC', label: 'South Carolina' },
  { postalCode: 'SD', label: 'South Dakota' },
  { postalCode: 'TN', label: 'Tennessee' },
  { postalCode: 'TX', label: 'Texas' },
  { postalCode: 'UT', label: 'Utah' },
  { postalCode: 'VT', label: 'Vermont' },
  { postalCode: 'VA', label: 'Virginia' },
  { postalCode: 'WA', label: 'Washington' },
  { postalCode: 'WV', label: 'West Virginia' },
  { postalCode: 'WI', label: 'Wisconsin' },
  { postalCode: 'WY', label: 'Wyoming' },
  { postalCode: 'DC', label: 'Washington, DC' },

  { postalCode: 'AB', label: 'Alberta' },
  { postalCode: 'BC', label: 'British Columbia' },
  { postalCode: 'MB', label: 'Manitoba' },
  { postalCode: 'ON', label: 'Ontario' },

  { postalCode: 'SK', label: 'Saskatchewan' },
  { postalCode: 'YT', label: 'Yukon Territory' },
  { postalCode: 'NB', label: 'New Brunswick' },
  { postalCode: 'NL', label: 'Newfoundland' },

  { postalCode: 'NT', label: 'Northwest Territories' },
  { postalCode: 'NS', label: 'Nova Scotia' },
  { postalCode: 'NU', label: 'Nunavut' },
  { postalCode: 'PE', label: 'Prince Edward Island' },
  { postalCode: 'QC', label: 'Quebec' },
]);



// WEBPACK FOOTER //
// ./src/api/siteDesignations/north-american-states.js